import React from "react";
import * as FaIcons from "react-icons/fa";
import * as BiIcons from "react-icons/bi";
import * as RiIcons from "react-icons/ri";
import * as SiIcons from "react-icons/si";

// Combine all icon sets into one object
const AllIcons = {
  ...FaIcons,
  ...BiIcons,
  ...RiIcons,
  ...SiIcons,
};

const SkillCard = ({ skill, index }) => {
  const IconComponent = AllIcons[skill?.icon];

  return (
    <div className="hover:shadow-sm w-full hover:shadow-rose-500 hover:transition-all hover:duration-1000 h-32 tooltip bg-base-300 py-6 text-center rounded-lg">
      <IconComponent
        style={{ color: skill?.color }}
        className="text-6xl block mx-auto dark:text-gray-600"
        aria-label={skill?.name}
      />
      <p>{skill?.name}</p>
    </div>
  );
};

export default SkillCard;
